// @ts-check
// ── Settings → Client app tabs: the Save button ─────────────────────────
//
// MOVED here from dashboard/app.js (2026-10-02), unchanged, under the standing
// rule that whatever is touched in app.js leaves it first (move and change in
// separate commits). The card's checkboxes are drawn and filled by
// modules/settings.js renderSettings().

import { loadSettings, saveSettingsToStorage, getSupabase } from './config.js';
import { showToast } from './utils.js';

/** The teasers switch's checkbox, when the card is on the page. */
const teasersSwitch = () => /** @type {HTMLInputElement|null} */ (document.getElementById('s-client-teasers'));

/**
 * Show the client teasers switch as saved (Clayton, 2026-10-02, decision 5).
 * It starts on: only a saved `false` shows it off, the same rule the server
 * reads (_shared/client-teasers.js).
 * @param {Record<string, any>} settings
 */
export function fillClientTeasersSwitch(settings) {
  const el = teasersSwitch();
  if (el) el.checked = settings?.clientTeasers !== false;
}

/**
 * Wire the Client app tabs card's Save button.
 *
 * Stored in coaches.settings.enabledTabs via save-coach-settings (read by the
 * client bootstrap via _shared/tab-config.js, intersected with platform
 * availability), the same settings blob as autoSuspend/formCheckVideo.
 */
export function wireClientAppTabsSave() {
  document.getElementById('btn-save-client-tabs')?.addEventListener('click', async () => {
    const TAB_KEYS = ['calendar', 'workouts', 'nutrition', 'checkins', 'sessions', 'courses', 'community', 'progress'];
    const enabledTabs = TAB_KEYS.filter(t => /** @type {HTMLInputElement|null} */ (document.getElementById('s-tab-' + t))?.checked);
    // The client teasers switch saves with the tabs it sits under. A missing
    // switch (an older page) saves nothing for it rather than turning it off.
    const sw = teasersSwitch();
    const clientTeasers = sw ? sw.checked : undefined;
    const settings = loadSettings();
    settings.enabledTabs = enabledTabs;
    if (clientTeasers !== undefined) settings.clientTeasers = clientTeasers;
    saveSettingsToStorage(settings);
    try {
      const supabase = getSupabase();
      const { data: { session: s } } = await supabase.auth.getSession();
      if (s) {
        await fetch('/.netlify/functions/save-coach-settings', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + s.access_token },
          body: JSON.stringify({ settings: clientTeasers === undefined ? { enabledTabs: enabledTabs } : { enabledTabs: enabledTabs, clientTeasers: clientTeasers } }),
        });
      }
    } catch {}
    showToast('Client app tabs saved.', 'success');
    /** @type {any} */ (document.getElementById('btn-save-client-tabs'))?._dirtyReset?.();
  });
}
